<template>
  <div class="page-showcase">

    <header-prop class="header-prop-showcase" title="Define" subtitle="app">
    </header-prop>

    <div-columns column-num="is-8" class="div-content" :div-style="{}">
      <div class="column">
        <div v-if="$route.params.type.toLowerCase() === 'ios'">
          <div v-for="project in projects" :key="project.name" style="margin-top:2em;margin-bottom:2em;" align="center">
            <h1 style="margin-top:2em;margin-bottom:0.5em;">{{ project.title }}</h1>
            <h4 style="margin-left:0.5em;margin-top:0em;margin-bottom:1em;" v-if="project.linkLabel && project.link"><a :href="project.link">{{ project.linkLabel }}</a></h4>
            <h4 style="margin-left:0.5em;margin-top:0em;margin-bottom:1em;" v-else-if="project.linkLabel && project.link === undefined">{{ project.linkLabel }}</h4>
            <div style="width:100%;display:inline-block;font-size:0;" align="left">
              <!-- <img :src="info.path" style="width:50%;flex: 0 0 auto;cursor:pointer;" /> -->
              <lightbox v-for="info in project.images" :key="info.path" :caption="project.title" :src="info.path" :album="'test'" style="display:inline-block;width:50%;cursor:pointer;"><img :src="info.path"  style="display:inline-block;" data-pin-nopin="true" /></lightbox>
            </div>
          </div>
        </div>
        <div v-else>
          <span>else</span>
        </div>
      </div>
    </div-columns>
  </div>
</template>

<script>
import Lightbox from 'vue-lightbox'
import DivColumns from '@/components/DivColumns'
import HeaderProp from '@/components/HeaderProp'
export default {
  name: 'showcase',
  components: {
    DivColumns,
    HeaderProp,
    Lightbox
  },
  metaInfo: {
    title: 'showcase'
  },
  data () {
    return {
      projects: [{
        name: 'komaneko',
        title: 'Komaneko',
        link: 'https://itunes.apple.com/us/app/interactive-childrens-book-komaneko-personalized-for/id830219665?mt=8',
        linkLabel: 'iTunes',
        images: []
      }, {
        name: 'duckchat',
        title: 'DuckChat',
        link: 'https://appadvice.com/app/duckchat/1159258005',
        linkLabel: 'AppAdvice',
        images: []
      }, {
        name: 'shortkard',
        title: 'ShortKard',
        linkLabel: 'not deployed',
        images: []
      }, {
        name: 'bloodknight',
        title: 'Relationship Management',
        linkLabel: 'internal use',
        images: []
      }]
    }
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    refresh () {
      this.projects.forEach((project) => {
        for (var i = 1; i <= 7; i++) {
          var imageInfo = {}
          imageInfo.path = './static/showcase-ios/' + project.name + '-' + ('00' + i).slice(-2) + '.png'
          project.images.push(imageInfo)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-showcase {

  .header-prop-showcase {
    // background-color: $color-blue;
  }

  .div-content {
    padding-top: 3em;
    padding-bottom: 3em;
    background-color: $color-blue;
    color: $color-white-transparent;

    h1, h2, h3, h4 {
      color: $color-white-transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Showcase.vue?103bd1b0